import * as SecureStore from 'expo-secure-store'
import { Platform } from 'react-native'

/**
 * Cross-platform storage wrapper.
 * - Native (iOS/Android): expo-secure-store (encrypted)
 * - Web: localStorage (SecureStore not available on web)
 */
export const storage = {
  get: async (key: string): Promise<string | null> => {
    try {
      if (Platform.OS === 'web') {
        return localStorage.getItem(key)
      }
      return await SecureStore.getItemAsync(key)
    } catch {
      return null
    }
  },

  set: async (key: string, value: string): Promise<void> => {
    try {
      if (Platform.OS === 'web') {
        localStorage.setItem(key, value)
        return
      }
      await SecureStore.setItemAsync(key, value)
    } catch {
      // Storage full or unavailable — silently ignore
    }
  },

  remove: async (key: string): Promise<void> => {
    try {
      if (Platform.OS === 'web') {
        localStorage.removeItem(key)
        return
      }
      await SecureStore.deleteItemAsync(key)
    } catch {
      // Silently ignore
    }
  },
}

export const TOKEN_KEY = 'forbrugeragent_token'
export const USER_ID_KEY = 'user_id'
export const HAS_LOGGED_IN_KEY = 'has_logged_in'
export const BIOMETRIC_PROMPTED_KEY = 'biometric_prompted'
export const ATTRIBUTION_CODE_KEY = 'attribution_code'
export const USP_SELECTION_KEY = 'usp_selection'
export const AB_BUCKET_KEY = 'ab_bucket_what_matters_v1'
